import createReducer, { mergeReducers } from "../../lib/createReducer";
import { RESTART_REQUEST, RESTART_SUCCESS, RESTART_ERROR } from "./action";

const init = {
  isFetching: false,
  fetchSuccess: false,
  hasError: false,
  payload: null,
  error: null,
};

const requestReducer = createReducer(
  RESTART_REQUEST,
  () => ({
    ...init,
    isFetching: true,
  }),
  true
);

const successReducer = createReducer(RESTART_SUCCESS, ({ response }) => ({
  isFetching: false,
  fetchSuccess: true,
  payload: response,
}));

const errorReducer = createReducer(RESTART_ERROR, ({ error }) => ({
  isFetching: false,
  hasError: true,
  error,
}));

export default mergeReducers([requestReducer, successReducer, errorReducer], init);
